@layer tbw-plugins {
  .header-cell[data-sort='asc']::after {
    content: '↑';
    margin-left: var(--tbw-spacing-xs, 0.25em);
    opacity: 0.8;
  }
  .header-cell[data-sort='desc']::after {
    content: '↓';
    margin-left: var(--tbw-spacing-xs, 0.25em);
    opacity: 0.8;
  }
  .sort-indicator {
    margin-left: var(--tbw-spacing-xs, 0.25em);
    opacity: 0.8;
  }
  .sort-index {
    font-size: var(--tbw-font-size-2xs, 0.7em);
    background: var(--tbw-multi-sort-badge-bg, var(--tbw-color-panel-bg));
    color: var(--tbw-multi-sort-badge-color, var(--tbw-color-fg));
    border-radius: 50%;
    width: var(--tbw-multi-sort-badge-size, 1em);
    height: var(--tbw-multi-sort-badge-size, 1em);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-left: var(--tbw-spacing-xs, 0.125em);
    font-weight: 600;
  }
} /* End @layer tbw-plugins */
